import React from 'react';
import Button from 'react-bootstrap/Button';
import {ConfirmationDialog} from "../../../common/Dialog";
import SomlService from "../../../services/soml-service";
import IconButton from "../../buttons/icon-button/IconButton";
import {WorkbenchStateContext} from "../../context/WorkbenchContext";
import BaseProps from "../../../types/BaseProps";
import classNames from "classnames";

type ActivateSchemaActionProps = BaseProps & {
  schemaId: string;
  onBeginActivate?: () => void
  onActivate: () => void;
  onFailedActivate?: (error?: any) => void;
  onAfterActivate?: () => void
  standardButton?: boolean;
  disabled?: boolean
  forbidden?: boolean
};

type ActivateSchemaActionState = {
  confirming: boolean;
};

class ActivateSchemaAction extends React.Component<ActivateSchemaActionProps, ActivateSchemaActionState> {

  static contextType = WorkbenchStateContext;

  constructor(props: ActivateSchemaActionProps) {
    super(props);
    this.state = {
      confirming: false
    };
    this.openConfirmDialog = this.openConfirmDialog.bind(this);
    this.hideConfirmDialog = this.hideConfirmDialog.bind(this);
    this.confirmActivate = this.confirmActivate.bind(this);
  }

  openConfirmDialog() {
    this.setState({
      confirming: true
    });
  }

  hideConfirmDialog() {
    this.setState({
      confirming: false
    });
  }

  beforeActivate() {
    this.props.onBeginActivate && this.props.onBeginActivate();
  }

  onActivation() {
    this.props.onActivate();
  }

  afterActivation() {
    this.props.onAfterActivate && this.props.onAfterActivate();
  }

  cannotActivate(error: any) {
    const msg = error.message ? ` Reason: ${error.message}` : '';
    console.error(`Schema was not activated! ${msg}`);
    this.props.onFailedActivate && this.props.onFailedActivate(error);
  }

  confirmActivate() {
    this.beforeActivate();
    SomlService.activateSchema(this.props.schemaId, this.context.configurations)
      .then(() => {
        this.setState({
          confirming: false
        }, () => this.onActivation());
      })
      .catch(err => this.cannotActivate(err))
      .finally(() => this.afterActivation());
  }

  render() {
    const classes = classNames("ActivateSchemaAction", this.props.className);
    const title = this.props.forbidden ? "Activate schema is forbidden" : "Activate schema";
    const isDisabled = this.props.forbidden || this.props.disabled;
    return (
      <>
        {
          this.props.standardButton && <Button className={classes}
                                               onClick={this.openConfirmDialog}
                                               title={title}
                                               disabled={isDisabled}>
            Activate
          </Button>
        }
        {
          !this.props.standardButton && <IconButton className={classes}
                                                    icon="toggle-on"
                                                    onClick={this.openConfirmDialog}
                                                    title={title}
                                                    disabled={isDisabled}/>
        }
        <ActivateSchemaConfirmation id={this.props.schemaId}
                                    confirming={this.state.confirming}
                                    onConfirm={this.confirmActivate}
                                    onCancel={this.hideConfirmDialog}/>
      </>
    );
  }

}

export default ActivateSchemaAction;

function ActivateSchemaConfirmation(props: {
  id: string,
  confirming: boolean,
  onConfirm: () => void,
  onCancel: () => void
}) {
  if (!props.confirming) {
    return null;
  }
  const message = <span>Are you sure you want to activate schema <b>{props.id}</b></span>;
  return (
    <ConfirmationDialog
      className="ActivateSchemaConfirmation"
      message={message}
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}/>
  );
}
